import { ThemeProvider } from '@/styles';
import { MainLayout } from '@/layout';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from '@/components/AppRouter';
import { QueryProvider } from '@/services/QueryProvider';
import { ToastHost } from '@/components/ToastHost';
import { CssBaseline } from '@mui/material';
import { reactPlugin } from './analytics'; // your analytics.tsx file
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';

function App() {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <QueryProvider>
        <ThemeProvider>
          <CssBaseline />
          <BrowserRouter>
            <MainLayout>
              <ToastHost />
              <AppRouter />
            </MainLayout>
          </BrowserRouter>
        </ThemeProvider>
      </QueryProvider>
    </AppInsightsContext.Provider>
  );
}

export default App;
